import { createClient } from '@supabase/supabase-js';
import { crossDomainStorage } from './crossDomainStorage';

export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6eGFibmFncWxhdHl0bHZ3cHlxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU1NDE4NzAsImV4cCI6MjA5MTExNzg3MH0.6liZxZtFY4FE8suxG7Ko9BlCfVh7GIZLv84AO7FHcMY';

// Use proxy through our own server to bypass network/firewall blocks on supabase.co
export const SUPABASE_URL = typeof window !== 'undefined'
  ? window.location.origin + '/supabase'
  : 'https://qzxabnagqlatytlvwpyq.supabase.co';

// ── Guarda de só-leitura durante impersonação (diretoria "vê como" consultor) ──
// Enquanto a flag araunah-imperson-active existir, bloqueia gravações de TABELA
// (/rest/v1 POST/PATCH/PUT/DELETE) e de STORAGE — a sessão ativa é a do consultor,
// então qualquer write sairia como se fosse ele. Auth, refresh, RPC e GET passam.
// Inline (sem import de impersonate.ts) pra evitar ciclo de import.
const IMPERSON_ACTIVE_KEY = 'araunah-imperson-active';
const guardedFetch: typeof fetch = (input, init) => {
  try {
    if (typeof localStorage !== 'undefined' && localStorage.getItem(IMPERSON_ACTIVE_KEY)) {
      const url = typeof input === 'string' ? input : input instanceof URL ? input.href : (input as Request).url;
      const method = (init?.method ?? (input instanceof Request ? input.method : 'GET')).toUpperCase();
      const isWrite = method === 'POST' || method === 'PUT' || method === 'PATCH' || method === 'DELETE';
      const isTableWrite = url.includes('/rest/v1/') && !url.includes('/rest/v1/rpc/');
      const isStorageWrite = url.includes('/storage/v1/object');
      if (isWrite && (isTableWrite || isStorageWrite)) {
        return Promise.resolve(new Response(
          JSON.stringify({ code: 'read_only_impersonation', message: 'Somente leitura enquanto você vê como outro consultor.' }),
          { status: 423, headers: { 'Content-Type': 'application/json' } },
        ));
      }
    }
  } catch { /* ignore */ }
  return fetch(input, init);
};

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: crossDomainStorage,
    storageKey: 'araunah-auth',
  },
  global: {
    headers: {
      'x-supabase-proxy': '1',
    },
    fetch: guardedFetch,
  },
});
